const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/sales/$id.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { checkCountryCode } from "@/lib/check-country";
import i18n from "@/lib/i18n";
import { getImage } from "@/lib/get-image";
import { httpClient } from "@/lib/http-client";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodSearchValidator } from "@tanstack/router-zod-adapter";
import { formSchema } from "@/stores/searchStore";
export const Route = createFileRoute("/{-$locale}/sales/$id")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async () => {},
  loader: async ({
    params,
    context
  }) => {
    const {
      queryClient,
      country
    } = context;
    const {
      id
    } = params;
    if (!checkCountryCode(country ?? "US")) {
      console.warn(`Invalid country code: ${country}`);
      throw redirect({
        to: "/{-$locale}/sales/$id",
        params: {
          id
        },
        search: {
          country: "US",
          page: 1
        },
        code: 302
      });
    }
    const [coverData, promotionData] = await Promise.allSettled([queryClient.fetchQuery({
      queryKey: ["promotion-cover", {
        id
      }],
      queryFn: () => httpClient.get<Pick<SingleOffer, "_id" | "id" | "namespace" | "title" | "keyImages">>(`/promotions/${id}/cover`).catch(() => null)
    }), queryClient.fetchQuery({
      queryKey: ["promotion-meta", {
        id,
        country
      }],
      queryFn: () => httpClient.get<{
        elements: SingleOffer[];
        title: string;
        start: number;
        page: number;
        count: number;
      }>(`/promotions/${id}`, {
        params: {
          country,
          page: 1,
          limit: 1
        }
      }).catch(() => null)
    })]);
    const cover = coverData.status === "fulfilled" ? coverData.value : null;
    const promotion = promotionData.status === "fulfilled" ? promotionData.value : null;
    return {
      cover,
      id,
      promotion,
      dehydratedState: dehydrate(queryClient)
    };
  },
  validateSearch: zodSearchValidator(formSchema),
  head: ctx => {
    if (!ctx.loaderData) {
      return {
        meta: [{
          title: i18n.t("sales.errors.notFound"),
          description: i18n.t("sales.errors.notFound")
        }]
      };
    }
    const {
      promotion
    } = ctx.loaderData;
    if (!promotion) return {
      meta: [{
        title: i18n.t("sales.errors.notFound"),
        description: i18n.t("sales.errors.notFound")
      }]
    };
    return {
      meta: [{
        title: i18n.t("sales.meta.title", {
          title: promotion.title
        })
      }, {
        name: "description",
        content: i18n.t("sales.meta.description", {
          title: promotion.title
        })
      }, {
        name: "og:title",
        content: i18n.t("sales.meta.title", {
          title: promotion.title
        })
      }, {
        name: "og:description",
        content: i18n.t("sales.meta.description", {
          title: promotion.title
        })
      }, {
        property: "twitter:title",
        content: i18n.t("sales.meta.title", {
          title: promotion.title
        })
      }, {
        property: "twitter:description",
        content: i18n.t("sales.meta.description", {
          title: promotion.title
        })
      }, {
        name: "og:image",
        content: getImage(ctx.loaderData.cover?.keyImages ?? [], ["OfferImageWide", "DieselGameBoxWide", "DieselStoreFrontWide"])?.url ?? "/placeholder.webp"
      }, {
        name: "og:type",
        content: "website"
      }, {
        name: "twitter:image",
        content: getImage(ctx.loaderData.cover?.keyImages ?? [], ["OfferImageWide", "DieselGameBoxWide", "DieselStoreFrontWide"])?.url ?? "/placeholder.webp"
      }]
    };
  }
});